import { render, staticRenderFns } from "./OrderFoodButton.vue?vue&type=template&id=3015beec&"
import script from "./OrderFoodButton.vue?vue&type=script&lang=js&"
export * from "./OrderFoodButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports